<template>
    <div>
        <p>处理成功: {{ form.successTotal }} 条</p>
        <p>处理失败: {{ form.failTotal }} 条</p>
        <p v-for="x in form.failMessages" :key="x">
            {{ x }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        form: Object
    }
}
</script>

<style>

</style>